import { useContext, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import { useNavigate } from 'react-router-dom';
import { useStatus } from "../../Contexts/Context_Status_Global";
import Icon_Hamburger from "../../Assets/Icons/Icon_Hamburger.png"
export default function UI_Panels_Controls() {
    const UI = useContext(Context_UI);
    // const Navigate = useNavigate();
    const { Panel_Toggle, Panel_Left_State, Panel_Right_State, Page_Properties } = useStatus();
    
    return (
        <>
            <ui-panels-controls id="Panels_Controls" State_Ribbon={Page_Properties.Ribbon.Enabled ? "Active" : "Inactive"}>
                <button className="UI_Panels_Control" id="Panel_Left_Control" Side="Left" State={Panel_Left_State} onClick={() => Panel_Toggle("Left")}>
                    <img src={Icon_Hamburger} className="UI_Panels_Control_Icon" draggable="false" loading="lazy" />
                    <p className="UI_Panels_Control_Title" id="Panel_Left_Control_Title">
                        {Page_Properties.Panels.Left.Title}
                    </p>
                </button>
                <button className="UI_Panels_Control" id="Panel_Right_Control" Side="Right" State={Panel_Right_State} onClick={() => Panel_Toggle("Right")}>
                    <img src={Icon_Hamburger} className="UI_Panels_Control_Icon" draggable="false" loading="lazy" />
                    <p className="UI_Panels_Control_Title" id="Panel_Right_Control_Title">
                        {Page_Properties.Panels.Right.Title}
                    </p>
                </button>
            </ui-panels-controls>
        </>
    )
}

